import { CookieKey } from '@/constants';
import { useGlobalState } from '@/hooks';
import { type IPanel, OnboardingStepName } from '@/interfaces';
import { gtmClickSkipLinkedIn, gtmLinkedInFollowSuccess } from '@/utils';
import Cookies from 'js-cookie';
import { useEffect } from 'react';
import { FollowUsWrapper, Iframe, Image, LinkedInWrapper, SkipButton } from './FollowUs.styles';

const FollowUs: React.FC<IPanel> = ({ image }) => {
  const { isFollowingLinkedIn, currentStep, setCurrentStep, userInfo, getProperImageUrl } = useGlobalState();

  const initFollow = Cookies.get(CookieKey.IsFollowing);
  const isBasicDetails = !!userInfo?.firstName && !!userInfo?.lastName && !!userInfo?.companyName;

  // biome-ignore lint/correctness/useExhaustiveDependencies: deps tracked manually; cookie reads are side effects
  useEffect(() => {
    const isFollowing = Cookies.get(CookieKey.IsFollowing);
    const isTriggerGTMFollowUsStep = initFollow === 'false' && isFollowing === 'true';
    if (isTriggerGTMFollowUsStep) {
      gtmLinkedInFollowSuccess(userInfo?.authenticationMethod);
    }
    if (currentStep === OnboardingStepName.followUs && isFollowing === 'true') {
      setCurrentStep(OnboardingStepName.aboutYou);
    }
  }, [isFollowingLinkedIn]);

  const onSkip = () => {
    gtmClickSkipLinkedIn(userInfo?.authenticationMethod);
    setCurrentStep(OnboardingStepName[isBasicDetails ? 'thankYou' : 'aboutYou']);
  };

  return (
    <FollowUsWrapper>
      <LinkedInWrapper>
        <Image
          src={getProperImageUrl(image)}
          alt='Follow Us'
          style={{
            objectFit: 'cover',
          }}
        />
        <Iframe />
      </LinkedInWrapper>
      <SkipButton onClick={onSkip}>SKIP FOR NOW</SkipButton>
    </FollowUsWrapper>
  );
};

export default FollowUs;
